// src/components/pages/Pessoa/helpers/applyPessoaExistente.js

export function applyPessoaExistente({
    result,
    setDados,
    setPessoaFisica,
    setPessoaJuridica,
    setPessoaEndereco,
    setPessoaEmail,
    setPessoaTelefone,
    setPessoaNome,
}) {
    if (!result) return;
    const isAdmin = result.isAdmin;

    setDados((prev) => ({
        ...prev,
        // Se for admin, espalha o objeto com uuid nulo. Se não for, espalha um objeto vazio (não altera nada)
        ...(isAdmin ? { uuid: null } : {}),
        // CPForCNPJ: result.CPForCNPJ || prev.CPForCNPJ || '',
        images: result.images || prev.images || null,
        RGorIE: result.RGorIE || '',
        inscricaoEstadualST: result.inscricaoEstadualST || '',
        nomePrincipal: result.nomePrincipal || '',
        tipo: result.tipo || prev.tipo,
        vinculoFinanceiro: result.vinculoFinanceiro || prev.vinculoFinanceiro || 'Ambos',
        descricao: result.descricao || prev.descricao || '',
        nomePrincipal: result.nomePrincipal || prev.nomePrincipal || '',
        razaoSocial: result.razaoSocial || prev.razaoSocial || '',
        nomeFantasia: result.nomeFantasia || prev.nomeFantasia || '',
    }));

    if (result.pessoaFisica) {
        setPessoaFisica(result.pessoaFisica || {});
    }

    if (result.pessoaJuridica) {
        setPessoaJuridica(result.pessoaJuridica || {});
    }

    setPessoaEndereco(Array.isArray(result.pessoaEnderecos) ? result.pessoaEnderecos : []);
    setPessoaEmail(Array.isArray(result.pessoaEmails) ? result.pessoaEmails : []);
    setPessoaTelefone(Array.isArray(result.pessoaTelefones) ? result.pessoaTelefones : []);
    setPessoaNome(Array.isArray(result.pessoaNomes) ? result.pessoaNomes : []);
}
